// extracted by mini-css-extract-plugin
module.exports = {"primaryButtonsContainer":"styles__primaryButtonsContainer___1DuXh","loader":"styles__loader___XG_y1","noAlertsContainer":"styles__noAlertsContainer___27nZX"};